import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";
import "swiper/css";
import "swiper/css/pagination";
import { SwiperSlide } from "swiper/react";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline as ContentSponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { ContentItemPostiesPrimary } from "scmp-app/components/content/content-item-render/variants/posties-primary";
import {
  StyledEntityLink as ContentItemPostiesPrimaryEntityLink,
  Headline as ContentItemPostiesPrimaryHeadline,
} from "scmp-app/components/content/content-item-render/variants/posties-primary/styles";
import { Button } from "scmp-app/components/posties/button";
import { Swiper } from "scmp-app/components/swiper";

import ChevronNext from "./chevron-next.svg";
import ChevronPrevious from "./chevron-previous.svg";

export const swiperElementClasses = {
  next: "big-read__swiper-button--next",
  previous: "big-read__swiper-button--previous",
};

export const Container = styled.div`
  position: relative;

  padding-block-end: 41px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline: 28px;
    padding-block-end: 22px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-inline: auto;
    padding-block-end: 31px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    padding-block-end: 44px;
  }
`;

export const SwiperButton = styled.div`
  cursor: pointer;
`;

export const StyledSwiperWrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin-inline: auto;

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 850px;
  }

  .${swiperElementClasses.previous}, .${swiperElementClasses.next} {
    position: absolute;
    inset-block-start: 30vw;
    z-index: 1;

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: 25vw;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-block-start: 240px;
    }
  }

  .${swiperElementClasses.previous} {
    inset-inline-start: -20px;

    ${theme.breakpoints.up("tablet")} {
      inset-inline-start: -55px;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-inline-start: 0;
    }
  }

  .${swiperElementClasses.next} {
    inset-inline-end: -20px;

    ${theme.breakpoints.up("tablet")} {
      inset-inline-end: -55px;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-inline-end: 0;
    }
  }
`;

export const StyledSwiper = styled(Swiper)`
  max-inline-size: 560px;
  padding-block: 0;
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 750px;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)``;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  text-transform: uppercase;
`;

const arrowStyle = css`
  inline-size: 20px;
  block-size: 20px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 43.2px;
    block-size: 43.2px;
  }

  ${theme.breakpoints.up("desktop")} {
    inline-size: 48px;
    block-size: 48px;
  }
`;

export const StyledChevronPrevious = styled(ChevronPrevious)`
  ${arrowStyle};
`;

export const StyledChevronNext = styled(ChevronNext)`
  ${arrowStyle};
`;

export const StyledContentItemPostiesPrimary = styled(ContentItemPostiesPrimary)`
  position: relative;

  margin-block-end: 29px;
  padding-inline: 10px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 54px;
    padding-inline: 14px;
  }

  ${ContentItemPostiesPrimaryEntityLink} {
    padding-inline: 0;
    ${theme.breakpoints.up("tablet")} {
      inline-size: unset;
    }
    ${theme.breakpoints.up("desktop")} {
      inline-size: unset;
    }
  }

  ${ContentItemPostiesPrimaryHeadline} {
    ${ContentHeadline}, ${ContentSponsorHeadline} {
      color: #1b4191;
      letter-spacing: -0.96px;

      ${theme.breakpoints.up("tablet")} {
        font-size: 28px;
        line-height: 32px;
        letter-spacing: -1.76px;
      }

      ${theme.breakpoints.up("desktop")} {
        font-size: 32px;
        line-height: 38px;
        letter-spacing: -1.92px;
      }
    }
  }

  ${Figure} {
    inset-block-start: 8px;
    inset-inline-end: 8px;
    ${theme.breakpoints.up("tablet")} {
      inset-block-start: 8px;
      inset-inline-end: 8px;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-block-start: 9px;
      inset-inline-end: 10px;
    }
  }
`;
